import React, { useState, useEffect } from 'react';
import { useNetwork } from '../NetworkContext';
import { FiCloudOff } from 'react-icons/fi';
import './OfflineModeBanner.css';

const OfflineModeBanner = () => {
  const { isOnline } = useNetwork();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      // Small delay to ensure the mount animation triggers correctly
      const timer = setTimeout(() => setIsVisible(true), 10);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isOnline]);

  if (isOnline && !isVisible) {
    return null;
  }

  return (
    <div className={`offline-mode-bar ${isVisible ? 'visible' : ''}`}>
      <div className="offline-mode-content">
        <div className="offline-pulse-dot" />
        <FiCloudOff className="offline-icon" />
        <div className="offline-text-group">
          <span className="offline-primary">Offline mode - live scoring only</span>
        </div>
      </div>
    </div>
  );
};

export default OfflineModeBanner;
